import { Delete } from "@mui/icons-material";
import { Button, IconButton, TextField } from "@mui/material";
import React from "react";

function UiItemsPage() {
  // const theme = useTheme();
  return (
    <div className="container mx-auto p-4">
      <div>
        <div className="text-3xl font-bold">Buttons</div>
        <div className="flex justify-start items-center gap-2 flex-wrap">
          <div className="border border-neutral-500 p-2 space-y-2">
            <div className="text-xl font-semibold">
              Variant: <em>containted</em>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Primary: </div>
              <Button variant="contained" color="primary" size="large">
                Large
              </Button>
              <Button variant="contained" color="primary" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="primary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Secondary: </div>
              <Button variant="contained" color="secondary" size="large">
                Large
              </Button>
              <Button variant="contained" color="secondary" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="secondary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Error: </div>
              <Button variant="contained" color="error" size="large">
                Large
              </Button>
              <Button variant="contained" color="error" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="error" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Info: </div>
              <Button variant="contained" color="info" size="large">
                Large
              </Button>
              <Button variant="contained" color="info" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="info" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Success: </div>
              <Button variant="contained" color="success" size="large">
                Large
              </Button>
              <Button variant="contained" color="success" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="success" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Warning: </div>
              <Button variant="contained" color="warning" size="large">
                Large
              </Button>
              <Button variant="contained" color="warning" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="warning" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>neutral Text: </div>
              <Button variant="contained" color="neutral" size="large">
                Large
              </Button>
              <Button variant="contained" color="neutral" size="medium">
                Medium
              </Button>
              <Button variant="contained" color="neutral" size="small">
                small
              </Button>
            </div>
          </div>
          <div className="border border-neutral-500 p-2 space-y-2">
            <div className="text-xl font-semibold">
              Variant: <em>Outlined</em>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Primary: </div>
              <Button variant="outlined" color="primary" size="large">
                Large
              </Button>
              <Button variant="outlined" color="primary" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="primary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Secondary: </div>
              <Button variant="outlined" color="secondary" size="large">
                Large
              </Button>
              <Button variant="outlined" color="secondary" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="secondary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Error: </div>
              <Button variant="outlined" color="error" size="large">
                Large
              </Button>
              <Button variant="outlined" color="error" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="error" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Info: </div>
              <Button variant="outlined" color="info" size="large">
                Large
              </Button>
              <Button variant="outlined" color="info" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="info" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Success: </div>
              <Button variant="outlined" color="success" size="large">
                Large
              </Button>
              <Button variant="outlined" color="success" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="success" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Warning: </div>
              <Button variant="outlined" color="warning" size="large">
                Large
              </Button>
              <Button variant="outlined" color="warning" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="warning" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>neutral Text: </div>
              <Button variant="outlined" color="neutral" size="large">
                Large
              </Button>
              <Button variant="outlined" color="neutral" size="medium">
                Medium
              </Button>
              <Button variant="outlined" color="neutral" size="small">
                small
              </Button>
            </div>
          </div>
          <div className="border border-neutral-500 p-2 space-y-2">
            <div className="text-xl font-semibold">
              Variant: <em>Text</em>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Primary: </div>
              <Button variant="text" color="primary" size="large" disabled>
                Large
              </Button>
              <Button variant="text" color="primary" size="medium">
                Medium
              </Button>
              <Button variant="text" color="primary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Secondary: </div>
              <Button variant="text" color="secondary" size="large">
                Large
              </Button>
              <Button variant="text" color="secondary" size="medium">
                Medium
              </Button>
              <Button variant="text" color="secondary" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Error: </div>
              <Button variant="text" color="error" size="large">
                Large
              </Button>
              <Button variant="text" color="error" size="medium">
                Medium
              </Button>
              <Button variant="text" color="error" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Info: </div>
              <Button variant="text" color="info" size="large">
                Large
              </Button>
              <Button variant="text" color="info" size="medium">
                Medium
              </Button>
              <Button variant="text" color="info" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Success: </div>
              <Button variant="text" color="success" size="large">
                Large
              </Button>
              <Button variant="text" color="success" size="medium">
                Medium
              </Button>
              <Button variant="text" color="success" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Warning: </div>
              <Button variant="text" color="warning" size="large">
                Large
              </Button>
              <Button variant="text" color="warning" size="medium">
                Medium
              </Button>
              <Button variant="text" color="warning" size="small">
                small
              </Button>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>neutral Text: </div>
              <Button variant="text" color="neutral" size="large">
                Large
              </Button>
              <Button variant="text" color="neutral" size="medium">
                Medium
              </Button>
              <Button variant="text" color="neutral" size="small">
                small
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-3xl font-bold">Icon Buttons</div>
        <div className="flex justify-start items-center gap-2 flex-wrap">
          <div className="space-x-2 flex items-center justify-start flex-wrap border border-neutral-500 p-2 space-y-2">
            <div className="space-x-2 flex justify-start items-center">
              <div>Primary: </div>
              <IconButton color="primary" size="large">
                <Delete />
              </IconButton>
              <IconButton color="primary" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="primary" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Secondary: </div>
              <IconButton color="secondary" size="large">
                <Delete />
              </IconButton>
              <IconButton color="secondary" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="secondary" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Info: </div>
              <IconButton color="info" size="large">
                <Delete />
              </IconButton>
              <IconButton color="info" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="info" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>warning: </div>
              <IconButton color="warning" size="large">
                <Delete />
              </IconButton>
              <IconButton color="warning" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="warning" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Error: </div>
              <IconButton color="error" size="large">
                <Delete />
              </IconButton>
              <IconButton color="error" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="error" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Default: </div>
              <IconButton color="default" size="large">
                <Delete />
              </IconButton>
              <IconButton color="default" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="default" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>neutral: </div>
              <IconButton color="neutralText" size="large">
                <Delete />
              </IconButton>
              <IconButton color="neutralText" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="neutralText" size="small">
                <Delete />
              </IconButton>
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Success: </div>
              <IconButton color="success" size="large">
                <Delete />
              </IconButton>
              <IconButton color="success" size="medium">
                <Delete />
              </IconButton>
              <IconButton color="success" size="small">
                <Delete />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-3xl font-bold">Text Field</div>
        <div className="flex justify-start items-center gap-2 flex-wrap">
          <div className="border border-neutral-500 p-2 space-y-2">
            <div className="space-x-2 flex justify-start items-center">
              <div>Enabled: </div>
              <TextField
                color="primary"
                size="small"
                label="Label"
                value="Value"
              />
              <TextField
                color="primary"
                size="medium"
                label="Label"
                value="Value"
              />
              <TextField color="primary" size="small" label="Label" />
              <TextField color="primary" size="medium" label="Label" />
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Error: </div>

              <TextField color="primary" size="small" error={true} />
              <TextField color="primary" size="medium" error={true} />
              <TextField
                color="primary"
                size="small"
                error={true}
                label="Label"
                value="Value"
              />
              <TextField
                color="primary"
                size="medium"
                error={true}
                label="Label"
                value="Value"
              />
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Disabled: </div>
              <TextField color="primary" size="small" disabled />
              <TextField color="primary" size="medium" disabled />
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Focused: </div>
              <TextField color="primary" size="small" autoFocus />
              <TextField color="primary" size="medium" autoFocus />
            </div>
            <div className="space-x-2 flex justify-start items-center">
              <div>Hovered: </div>
              <TextField color="primary" size="small" />
              <TextField color="primary" size="medium" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UiItemsPage;
